import styled from "styled-components";

export const IconStack = styled.span`
  display: grid;
  cursor: pointer;
  svg {
    grid-area: 1 / 1;
  }
`;
